import * as React from "react"

function Iso9001Component(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={130.448}
      height={127.284}
      viewBox="0 0 130.448 127.284"
      {...props}
    >
      <title>
        Iso 9001
      </title>
      <defs>
        <style>
          {
            ".prefix__a{fill:#e74e00}.prefix__b{fill:#696868}.prefix__d{fill:#fff}.prefix__e{fill:none;stroke:#fff;stroke-miterlimit:3.864;stroke-width:.073px}"
          }
        </style>
      </defs>
      <path
        className="prefix__a"
        d="M61.412 76.829L50.964 66.402V50.579l10.448 10.439 23.741-23.755a33.448 33.448 0 106.56 9.253z"
      />
      <path
        className="prefix__b"
        d="M81.85 122.095c-3.057-.938-3.669-3.588-3.5-6.508h4.434c0 2.017.083 3.711 2.511 3.711a2.109 2.109 0 002.225-2.4c0-3.794-8.894-4.025-8.894-10.295 0-3.307 1.578-5.936 6.966-5.936 4.3 0 6.435 1.935 6.154 6.343h-4.309c0-1.587-.269-3.18-2.053-3.18a2.051 2.051 0 00-2.282 2.232c0 4.023 8.906 3.664 8.906 10.295 0 3.65-1.807 5.15-4 5.74zM102.759 107.505c.026-1.956-.293-3.678-2.627-3.678-2.761 0-2.761 3.7-2.761 7.8 0 6.586.659 7.758 3.158 7.758a6.891 6.891 0 002.2-.411v-4.658h-2.4v-3.26h6.813v10.692c-.468.092-1.2.21-2.041.342h-7.562c-4.091-1.023-4.649-4.262-4.649-10.72 0-5.313.267-10.711 7.5-10.711 4.337 0 7.016 2.424 6.756 6.841zM115.494 100.664c3.869 0 5.97 1.5 6.26 4.9v1.443h-4.283c0-1.535-.38-3.18-2.183-3.18a2.055 2.055 0 00-2.284 2.232c0 3.706 7.6 3.688 8.75 8.9v3.056a4.9 4.9 0 01-3.836 4.077h-6.161c-3.057-.938-3.659-3.588-3.477-6.51h4.41c0 2.017.094 3.714 2.53 3.714 1.491 0 2.2-.964 2.2-2.4 0-3.794-8.88-4.025-8.88-10.295 0-3.307 1.573-5.922 6.955-5.936"
      />
      <path className="prefix__a" d="M65.1 122.066h65.348v.862H65.1z" />
      <path
        className="prefix__a"
        d="M121.731 96.792h.843v30.492h-.843zM10.77 67.674l-.2-1.76-9.571 1.061-.279.032.178 1.746 9.585-1.047zM5.015 76.186c1.753-.364 2.176-1.887 2.518-3.114.267-.966.5-1.8 1.247-1.956a1.051 1.051 0 011.3.9c.168.829-.142 1.212-1.136 1.417l-.279.057.369 1.776.272-.045a3 3 0 002.072-1.15 2.913 2.913 0 00.291-2.3 2.757 2.757 0 00-3.388-2.384c-1.642.345-2.048 1.784-2.4 3.05-.281.995-.522 1.852-1.283 2.013a1.21 1.21 0 01-.931-.116 1.508 1.508 0 01-.557-1 1.21 1.21 0 011.075-1.538l.574-.09-.352-1.727-.276.05a3.376 3.376 0 00-2.306 1.24 3.025 3.025 0 00-.293 2.391c.364 1.706 1.311 2.61 2.7 2.61a3.935 3.935 0 00.783-.084zM11.604 82.794a3.456 3.456 0 002.053-1.687 3.694 3.694 0 00-1.609-4.4 3.407 3.407 0 00-2.643.033l-2.894 1.049c-2.495.917-3.307 2.306-2.554 4.368a2.754 2.754 0 002.717 2.126 6.132 6.132 0 002.055-.428zm.56-3.64a1.39 1.39 0 01.019 1.072 1.864 1.864 0 01-1.139.879L8.06 82.192c-1.977.718-2.367.168-2.643-.565-.265-.772-.31-1.417 1.665-2.143l2.965-1.1a2.664 2.664 0 01.876-.175 1.313 1.313 0 01.574.12 1.365 1.365 0 01.662.827zM14.254 91.863l.144.243.069-.04c1.477-.869 2.873-1.689 3.187-2.91a2.446 2.446 0 00-.376-1.906c-.628-1.058-2.048-1.89-3.988-.751-2.487 1.491-1.762 3.154-1.479 3.628a2.123 2.123 0 00.952.9c-.992.567-1.767.954-2.232.822a.661.661 0 01-.4-.34.653.653 0 01-.092-.5 1.285 1.285 0 01.626-.69l.248-.144-.9-1.507-.246.139a2.633 2.633 0 00-1.3 1.58 2.74 2.74 0 001.8 3.128 2.329 2.329 0 00.56.069 7.859 7.859 0 003.555-1.472zm.9-2.28c-1.193.713-1.6.413-1.84.028s-.3-.9.907-1.606a2.363 2.363 0 011.153-.411.717.717 0 01.673.394c.201.334.323.865-.888 1.595zM18.544 97.619l.232.182c1.361-1.051 2.646-2.046 2.8-3.3a2.464 2.464 0 00-.609-1.847 2.439 2.439 0 00-1.63-1.042c-1.24-.121-2.513.839-3.857 1.887l-.13.1c-1.8 1.41-3.839 3.014-2.18 5.138a2.439 2.439 0 001.616 1.023 2.4 2.4 0 00.262.017c1.188 0 2.435-.973 3.643-1.916zm-4.3-.35c.076-.628 1-1.346 1.812-1.977l.236-.184c1.207-.95 2.254-1.772 2.9-1.772h.085a.664.664 0 01.458.288c.548.7-.354 1.46-2.28 2.969l-.229.182c-.772.6-1.743 1.384-2.369 1.28a.67.67 0 01-.461-.283.65.65 0 01-.151-.502zM23.525 102.752l.2.2.078-.073c1.675-1.7 3.409-3.451 1.481-5.358a2.442 2.442 0 00-1.741-.829c-1.252 0-2.393 1.148-3.6 2.358l-.151.154c-1.58 1.618-3.369 3.451-1.462 5.351a2.4 2.4 0 001.708.8c1.3 0 2.544-1.25 3.683-2.393zm-1.37-.728c-.7.723-1.585 1.623-2.239 1.628a.671.671 0 01-.491-.222.656.656 0 01-.224-.484c0-.633.858-1.5 1.547-2.192l.215-.217c1.082-1.091 2.1-2.121 2.747-2.121a.658.658 0 01.48.227c.628.628-.165 1.491-1.883 3.236zM29.579 101.508h-.1a10.343 10.343 0 01-1.776-.08l-.184-.05-1.143 1.486 1.6.1-4.562 5.866 1.4 1.082 5.887-7.533z"
      />
      <g>
        <path
          d="M122.473 91.857v-30.62A61.236 61.236 0 100 61.237c0 .042 12.246.042 12.246 0a48.99 48.99 0 1197.98 0v30.62z"
          fillRule="evenodd"
          fill="#696868"
        />
        <path
          className="prefix__d"
          d="M22.527 24.375l.13.125a.989.989 0 001.528.019.958.958 0 00.043-1.5c-1-.957-2.823 1.169-4.176-.128a1.653 1.653 0 01.047-2.5 1.535 1.535 0 012.511.017l-.574.6c-.487-.48-.959-.635-1.479-.092a.867.867 0 000 1.325c.992.952 2.787-1.207 4.214.165a1.885 1.885 0 01-2.79 2.535z"
        />
        <path
          className="prefix__e"
          d="M22.527 24.375l.13.125a.989.989 0 001.528.019.958.958 0 00.043-1.5c-1-.957-2.823 1.169-4.176-.128a1.653 1.653 0 01.047-2.5 1.535 1.535 0 012.511.017l-.574.6c-.487-.48-.959-.635-1.479-.092a.867.867 0 000 1.325c.992.952 2.787-1.207 4.214.165a1.885 1.885 0 01-2.79 2.535z"
        />
        <path
          className="prefix__d"
          d="M24.799 16.186l.607-.527 1.248 4.035 1.559 1.793-.6.522-1.559-1.793-3.8-1.817.673-.586 2.9 1.479z"
        />
        <path
          className="prefix__e"
          d="M24.799 16.186l.607-.527 1.248 4.035 1.559 1.793-.6.522-1.559-1.793-3.8-1.817.673-.586 2.9 1.479z"
        />
        <path
          className="prefix__d"
          d="M29.538 18.036l.106.146a.986.986 0 001.5.3.954.954 0 00.314-1.469c-.806-1.122-2.986.635-4.08-.886a1.65 1.65 0 01.5-2.443 1.535 1.535 0 012.466.472l-.673.484c-.392-.557-.829-.8-1.439-.359a.869.869 0 00-.246 1.3c.8 1.115 2.958-.678 4.11.928a1.883 1.883 0 01-3.2 1.987z"
        />
        <path
          className="prefix__e"
          d="M29.538 18.036l.106.146a.986.986 0 001.5.3.954.954 0 00.314-1.469c-.806-1.122-2.986.635-4.08-.886a1.65 1.65 0 01.5-2.443 1.535 1.535 0 012.466.472l-.673.484c-.392-.557-.829-.8-1.439-.359a.869.869 0 00-.246 1.3c.8 1.115 2.958-.678 4.11.928a1.883 1.883 0 01-3.2 1.987z"
        />
        <path
          className="prefix__d"
          d="M33.94 10.007l.35.6-1.413.828 2.8 4.788-.685.4-2.8-4.791-1.417.832-.347-.6z"
        />
        <path
          className="prefix__e"
          d="M33.94 10.007l.35.6-1.413.828 2.8 4.788-.685.4-2.8-4.791-1.417.832-.347-.6z"
        />
        <path
          className="prefix__d"
          d="M37.835 15.026L35.17 9.383l2.908-1.372.3.626-2.19 1.032.857 1.814 2.032-.959.3.624-2.032.961.921 1.954 2.235-1.056.3.626z"
        />
        <path
          className="prefix__e"
          d="M37.835 15.026L35.17 9.383l2.908-1.372.3.626-2.19 1.032.857 1.814 2.032-.959.3.624-2.032.961.921 1.954 2.235-1.056.3.626z"
        />
        <path
          className="prefix__d"
          d="M42.439 12.949l-.706.236-1.98-5.92 1.224-.409 3.154 4.469h.014l-.151-5.473 1.245-.416 1.98 5.918-.754.253-1.76-5.263-.017.007.1 5.816-.713.239-3.383-4.72h-.017z"
        />
        <path
          className="prefix__e"
          d="M42.439 12.949l-.706.236-1.98-5.92 1.224-.409 3.154 4.469h.014l-.151-5.473 1.245-.416 1.98 5.918-.754.253-1.76-5.263-.017.007.1 5.816-.713.239-3.383-4.72h-.017z"
        />
        <path
          className="prefix__d"
          d="M52.471 5.749a1.475 1.475 0 00-.324-.867 1.056 1.056 0 00-.735-.151.977.977 0 00-.853.628c-.014.073-.142.25.028 1.309l.267 1.644c.246 1.512.77 1.609 1.375 1.512.239-.04.95-.241.763-1.446l.81-.132c.35 1.939-1.023 2.161-1.424 2.228-.768.123-1.951.262-2.341-2.124l-.281-1.739c-.281-1.741.406-2.36 1.616-2.556s1.79.357 1.909 1.564z"
        />
        <path
          className="prefix__e"
          d="M52.471 5.749a1.475 1.475 0 00-.324-.867 1.056 1.056 0 00-.735-.151.977.977 0 00-.853.628c-.014.073-.142.25.028 1.309l.267 1.644c.246 1.512.77 1.609 1.375 1.512.239-.04.95-.241.763-1.446l.81-.132c.35 1.939-1.023 2.161-1.424 2.228-.768.123-1.951.262-2.341-2.124l-.281-1.739c-.281-1.741.406-2.36 1.616-2.556s1.79.357 1.909 1.564z"
        />
        <path
          className="prefix__d"
          d="M55.234 9.956l-.437-6.222 3.206-.227.05.69-2.414.17.139 2 2.242-.156.05.69-2.242.156.151 2.157 2.466-.175.047.69z"
        />
        <path
          className="prefix__e"
          d="M55.234 9.956l-.437-6.222 3.206-.227.05.69-2.414.17.139 2 2.242-.156.05.69-2.242.156.151 2.157 2.466-.175.047.69z"
        />
        <path
          className="prefix__d"
          d="M60.352 6.853l-.035 2.865-.791-.009.073-6.232 2.152.026a1.408 1.408 0 011.474 1.573 1.349 1.349 0 01-1.157 1.41v.017c.716.12.971.366 1 1.618a9.227 9.227 0 00.2 1.635l-.829-.012a7.115 7.115 0 01-.223-2.075.822.822 0 00-.931-.806zm.009-.69l1.191.014c.569.007.853-.482.857-1.025a.843.843 0 00-.824-.959l-1.2-.017z"
        />
        <path
          className="prefix__e"
          d="M60.352 6.853l-.035 2.865-.791-.009.073-6.232 2.152.026a1.408 1.408 0 011.474 1.573 1.349 1.349 0 01-1.157 1.41v.017c.716.12.971.366 1 1.618a9.227 9.227 0 00.2 1.635l-.829-.012a7.115 7.115 0 01-.223-2.075.822.822 0 00-.931-.806zm.009-.69l1.191.014c.569.007.853-.482.857-1.025a.843.843 0 00-.824-.959l-1.2-.017z"
        />
        <path
          className="prefix__d"
          d="M68.351 3.906l-.057.69-1.635-.139-.468 5.525-.791-.066.465-5.525-1.635-.137.057-.69z"
        />
        <path
          className="prefix__e"
          d="M68.351 3.906l-.057.69-1.635-.139-.468 5.525-.791-.066.465-5.525-1.635-.137.057-.69z"
        />
        <path
          className="prefix__d"
          d="M68.763 10.272l.873-6.177.787.112-.874 6.176z"
        />
        <path
          className="prefix__e"
          d="M68.763 10.272l.873-6.177.787.112-.874 6.176z"
        />
        <path
          className="prefix__d"
          d="M70.95 10.595l1.219-6.118 3.033.6-.137.678-2.254-.449-.39 1.965 2.136.425-.135.678-2.138-.425-.555 2.795z"
        />
        <path
          className="prefix__e"
          d="M70.95 10.595l1.219-6.118 3.033.6-.137.678-2.254-.449-.39 1.965 2.136.425-.135.678-2.138-.425-.555 2.795z"
        />
        <path
          className="prefix__d"
          d="M74.876 11.446l1.578-6.033.768.2-1.578 6.034z"
        />
        <path
          className="prefix__e"
          d="M74.876 11.446l1.578-6.033.768.2-1.578 6.034z"
        />
        <path
          className="prefix__d"
          d="M81.152 8.634a1.458 1.458 0 00.12-.917 1.042 1.042 0 00-.579-.48.963.963 0 00-1.047.156c-.047.057-.243.154-.588 1.169l-.536 1.58c-.494 1.446-.078 1.781.5 1.98.229.076.954.232 1.354-.921l.777.265c-.6 1.878-1.92 1.429-2.3 1.3-.737-.25-1.85-.683-1.07-2.974l.567-1.67c.567-1.67 1.465-1.895 2.627-1.5s1.415 1.158.952 2.277z"
        />
        <path
          className="prefix__e"
          d="M81.152 8.634a1.458 1.458 0 00.12-.917 1.042 1.042 0 00-.579-.48.963.963 0 00-1.047.156c-.047.057-.243.154-.588 1.169l-.536 1.58c-.494 1.446-.078 1.781.5 1.98.229.076.954.232 1.354-.921l.777.265c-.6 1.878-1.92 1.429-2.3 1.3-.737-.25-1.85-.683-1.07-2.974l.567-1.67c.567-1.67 1.465-1.895 2.627-1.5s1.415 1.158.952 2.277z"
        />
        <path
          className="prefix__d"
          d="M85.527 8.563l.919.425-.775 6.514-.808-.373.215-1.538-2.187-1.011-1.049 1.153-.731-.339zm.13.869l-.014-.007-2.282 2.61 1.81.836z"
        />
        <path
          className="prefix__e"
          d="M85.527 8.563l.919.425-.775 6.514-.808-.373.215-1.538-2.187-1.011-1.049 1.153-.731-.339zm.13.869l-.014-.007-2.282 2.61 1.81.836z"
        />
        <path
          className="prefix__d"
          d="M91.947 11.98l-.345.6-1.422-.822-2.773 4.8-.69-.4 2.778-4.8-1.422-.822.347-.6z"
        />
        <path
          className="prefix__e"
          d="M91.947 11.98l-.345.6-1.422-.822-2.773 4.8-.69-.4 2.778-4.8-1.422-.822.347-.6z"
        />
        <path
          className="prefix__d"
          d="M89.597 17.934l3.517-5.15.656.447-3.517 5.15z"
        />
        <path
          className="prefix__e"
          d="M89.597 17.934l3.517-5.15.656.447-3.517 5.15z"
        />
        <path
          className="prefix__d"
          d="M92.912 17.443l1.292-1.583a1.962 1.962 0 113.036 2.483l-1.295 1.585c-1.1 1.335-2.025 1.458-3.043.621s-1.087-1.769.009-3.106m2.383 2l1.332-1.63c.824-1.009.158-1.611-.035-1.769s-.917-.695-1.743.314l-1.335 1.63c-.862 1.056-.775 1.576-.194 2.05s1.108.461 1.975-.6"
        />
        <path
          className="prefix__e"
          d="M92.912 17.443l1.292-1.583a1.962 1.962 0 113.036 2.483l-1.295 1.585c-1.1 1.335-2.025 1.458-3.043.621s-1.087-1.769.01-3.106zm2.383 2l1.332-1.63c.824-1.009.158-1.611-.035-1.769s-.917-.695-1.743.314l-1.335 1.63c-.862 1.056-.775 1.576-.194 2.05s1.108.457 1.975-.599z"
        />
        <path
          className="prefix__d"
          d="M103.015 21.434l-4.512 4.307-.751-.787 2.209-5.518-.012-.014-3.912 3.74-.489-.513 4.512-4.311.775.813-2.183 5.445.012.012 3.86-3.69z"
        />
        <path
          className="prefix__e"
          d="M103.015 21.434l-4.512 4.307-.751-.787 2.209-5.518-.012-.014-3.912 3.74-.489-.513 4.512-4.311.775.813-2.183 5.445.012.012 3.86-3.69z"
        />
      </g>
    </svg>
  )
}

export default Iso9001Component